import React from 'react'
import dynamic from 'next/dynamic'
import LazyLoader from 'react-lazyload'

type PropsOf<T> = T extends React.ComponentType<infer Props> ? Props : never

// This is 100% type safe! The TS compiler doesn't need the type constraint here.
// Other options (unknown, never, and {}) fail to properly infer the prop types.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type LazyLoadProps<T extends React.ComponentType<any>> = PropsOf<T> & {
  loader: () => Promise<{ default: T }>
  height?: number
  offset?: number
  once?: boolean
  ssr?: boolean
  placeholder?: React.ReactNode
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const LazyLoad = <T extends React.ComponentType<any>>({
  loader,
  height = 200,
  once = true,
  offset = 100,
  ssr = true,
  placeholder,
  ...props
}: LazyLoadProps<T>) => {
  const Component = dynamic(loader, { ssr })

  return (
    <LazyLoader
      height={height}
      once={once}
      offset={offset}
      placeholder={placeholder}
    >
      <Component {...props} />
    </LazyLoader>
  )
}

export default LazyLoad
